import React from "react";
import _ from "lodash";
import { formatDateToMMDDYYYY } from "../../lib/constant";
import "./AccountDetail.css";

const OrderDetails = ({ setselectedTab, data }) => {
  const getStatusClass = (status) => {
    const statusLower = status?.toLowerCase() || '';
    if (statusLower === 'delivered' || statusLower === 'completed') {
      return 'delivered';
    } else if (statusLower === 'pending' || statusLower === 'processing') {
      return 'pending';
    } else if (statusLower === 'cancelled' || statusLower === 'failed') {
      return 'cancelled';
    }
    return 'pending';
  };

  const getStatusIcon = (status) => {
    const statusLower = status?.toLowerCase() || '';
    if (statusLower === 'delivered' || statusLower === 'completed') {
      return 'fas fa-check-circle';
    } else if (statusLower === 'pending' || statusLower === 'processing') {
      return 'fas fa-clock';
    } else if (statusLower === 'cancelled' || statusLower === 'failed') {
      return 'fas fa-times-circle';
    }
    return 'fas fa-clock';
  };

  return (
    <div className="order-details-container">
      <div className="order-details-header">
        <div className="order-details-title">
          <i className="far fa-shopping-bag"></i>
          <h3>My Orders</h3>
        </div>
        <p className="order-details-subtitle">Track and manage all your orders</p>
      </div>

      {!_.isEmpty(data) ? (
        <div className="orders-grid">
          {data?.map((item, index) => (
            <div className="order-card" key={item.id || index}>
              <div className="order-card-header">
                <div className="order-id">
                  <i className="far fa-receipt"></i> Order #{item?.id || index + 1}
                </div>
                <div className="order-date">
                  <i className="far fa-calendar-alt"></i>
                  {formatDateToMMDDYYYY(new Date(item?.created_at))}
                </div>
              </div>

              <div className="order-card-body">
                <div className="order-info-grid">
                  <div className="order-info-item">
                    <div className="order-info-label">Shipping Address</div>
                    <div className="order-info-value">
                      {item?.shipping_address || 'N/A'}
                    </div>
                  </div>

                  <div className="order-info-item">
                    <div className="order-info-label">Sub Total</div>
                    <div className="order-info-value">
                      ₹{item?.sub_total || 0}
                    </div>
                  </div>

                  <div className="order-info-item">
                    <div className="order-info-label">Tax Amount</div>
                    <div className="order-info-value">
                      ₹{item?.tax_amount || 0}
                    </div>
                  </div>

                  <div className="order-info-item">
                    <div className="order-info-label">Payment Method</div>
                    <div className="order-info-value">
                      {item?.payment_method || 'Online'}
                    </div>
                  </div>
                </div>
              </div>

              <div className="order-card-footer">
                <div className="order-total">
                  <span style={{ fontSize: '14px', color: '#6b7280', fontWeight: '400' }}>Total: </span>
                  ₹{item?.total_amount || 0}
                </div>
                <div className={`order-status ${getStatusClass(item?.status)}`}>
                  <i className={getStatusIcon(item?.status)}></i> {item?.status || 'Pending'}
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="empty-state-card">
          <div className="empty-state-icon">
            <i className="far fa-shopping-bag"></i>
          </div>
          <h4>No Orders Yet</h4>
          <p>You haven't placed any orders yet. Start shopping and your orders will appear here!</p>
          <a href="/" className="empty-state-btn">
            <i className="far fa-shopping-cart"></i> Start Shopping
          </a>
        </div>
      )}
    </div>
  );
};

export default OrderDetails;
